export default __webpack_public_path__ + "images/205c5870084d33fc9996cf4bf0ca31d8.png";